/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EntityIds
 */
export interface EntityIds {
}

/**
 * Check if a given object implements the EntityIds interface.
 */
export function instanceOfEntityIds(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EntityIdsFromJSON(json: any): EntityIds {
    return EntityIdsFromJSONTyped(json, false);
}

export function EntityIdsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityIds {
    return json;
}

export function EntityIdsToJSON(value?: EntityIds | null): any {
    return value;
}

